// Action Cable channels
// This imports the consumer and makes it available for Turbo Streams
import consumer from "./consumer"

// Make consumer available globally for turbo-rails
window.Turbo = window.Turbo || {}
window.Turbo.cable = consumer
